import React, { memo } from 'react';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import type { Option } from './labelForm';
import { denseInputSx, inputSx } from './styles';

interface SelectInputProps {
  value: string;
  options: readonly Option[];
  onChange: (value: string) => void;
  dense?: boolean;
  /** Shown when `value` is empty. */
  placeholder?: string;
  disabled?: boolean;
  /** Accessible name for the combobox (FormField's <label> does not reach MUI's display element). */
  label?: string;
}

const MENU_PROPS = { PaperProps: { sx: { maxHeight: 320, borderRadius: 2 } } };

const SelectInput: React.FC<SelectInputProps> = ({ value, options, onChange, dense, placeholder, disabled, label }) => (
  <Select
    value={value}
    onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
    input={<OutlinedInput sx={dense ? denseInputSx : inputSx} />}
    displayEmpty={!!placeholder}
    disabled={disabled}
    MenuProps={MENU_PROPS}
    SelectDisplayProps={label ? ({ 'aria-label': label } as React.HTMLAttributes<HTMLDivElement>) : undefined}
    renderValue={
      placeholder
        ? (v: string) => options.find((o) => o.value === v)?.label ?? <span style={{ opacity: 0.6 }}>{placeholder}</span>
        : undefined
    }
  >
    {options.map((o) => (
      <MenuItem key={o.value} value={o.value}>
        {o.label}
      </MenuItem>
    ))}
  </Select>
);

export default memo(SelectInput);
